import {DatepickerControlInterface} from '../../interfaces';

import {BaseControl} from './base-control';

export class DatepickerControl extends BaseControl<string> {
    minDate: string;
    maxDate: string;
    startDateAt: Date;
    resetable: boolean;

    constructor(data: DatepickerControlInterface) {
        super(data);

        this.resetable = data.resetable;
        this.minDate = !data.minDate ? null : data.minDate;
        this.maxDate = !data.maxDate ? null : data.maxDate;
        this.startDateAt = data.startDateAt ?? null;
    }
}
